// protocol/codes.ts
export const REJECT_CODES = [
  'invalid', 'rate_limited', 'not_allowed', 'not_found', 'too_far', 'gone', 'busy', 'server_error',
  'pockets_full', 'storage_full', 'not_enough_bells', 'too_long', 'hand_full',
  'closed', 'sold_out', 'already_bought', 'not_sellable',
  'no_loan', 'loan_unpaid', 'upgrade_pending', 'max_level', 'bad_amount',
  'not_ready', 'blocked_tile', 'bad_ground', 'overlap', 'out_of_bounds', 'door_tile', 'not_your_yard', 'not_placeable',
  'no_tool', 'no_bite', 'too_early', 'too_late',
  'no_stationery', 'recipient_blocked', 'recipient_unknown',
  'door_locked', 'owner_away', 'villager_away', 'villager_busy', 'asleep',
  'already_donated', 'not_donatable', 'unidentified',
] as const;
export type RejectCode = (typeof REJECT_CODES)[number];       // every code has string `reject.<code>`
export type FatalCode = 'update_required' | 'not_resident' | 'town_closed' | 'replaced' | 'abuse' | 'server_error';
export const CLOSE = {
  normal: 4000, replaced: 4001, notResident: 4003, townClosed: 4004, abuse: 4008, updateRequired: 4026, serverError: 4500,
} as const;
